import React, { useEffect } from "react";
import { message } from "antd";

import { AppLoader } from "../../../@crema";
import { useDispatch, useSelector } from "react-redux";
import { hideMessage } from "../../../redux/actions";
import AwesomeDebouncePromise from "awesome-debounce-promise";

message.config({
  top: 100, // Change the top position if needed
  duration: 2, // Default duration in seconds
  maxCount: 3, // Maximum number of messages to display
  getContainer: () => document.body, // Specify the container for messages
  // Increase the zIndex value
  style: {
    zIndex: 9999, // Set the desired zIndex value
  },
});

const showMessageToast = (msg, dispatch) => {
  message.success(msg);
  dispatch(hideMessage());
};

const debouncedMessageToast = AwesomeDebouncePromise(showMessageToast, 500, {
  onlyResolvesLast: true,
});

const showErrorToast = (error, dispatch) => {
  message.error(error);
  dispatch(hideMessage());
};

const debouncedErrorToast = AwesomeDebouncePromise(showErrorToast, 500, {
  onlyResolvesLast: true,
});

const AppInfoView = () => {
  const { loading, error, displayMessage } = useSelector(
    ({ common }) => common
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (error) {
      debouncedErrorToast(error, dispatch);
    }
  }, [error]);

  useEffect(() => {
    if (displayMessage) {
      debouncedMessageToast(displayMessage, dispatch);
    }
  }, [displayMessage]);

  return <>{loading ? <AppLoader /> : null}</>;
};

export default AppInfoView;
